import { createConfiguration } from '@repo/api-gw-sdk';

export const createConfig = (baseUrl: string, authToken: string | undefined) =>
  createConfiguration({
    baseUrl,
    ...(authToken
      ? {
          authMethods: {
            ApiKeyAuth: `Bearer ${authToken}`,
          },
        }
      : {}),
    timeout: 2 * 60_000, // 2 minutes default timeout, can be overridden per request
    retries: 5, // Retry idempotent request 5 times
  });
